export default __webpack_public_path__ + "static/media/us-as.6879a52e.svg";